import type { MapFeedItemDTO } from "../../data/types";
import { musicStatus, musicStatusLine } from "../../utils/venueMusic";
import CrowdChip from "../CrowdChip";
import DefaultAvatar from "../DefaultAvatar";
import LiveIcon from "../icons/LiveIcon";

type Props = {
  item: MapFeedItemDTO;
  /**
   * Kartkortet säger redan "No live data available" mitt i kortet, så där
   * hade raden under namnet bara upprepat det. Venue-sidan har ingen sådan
   * ruta och visar den.
   */
  showNoLiveDataStatus?: boolean;
};

/** Avatar, namn, adress, status och trängsel. Samma rad på kortet och sidan. */
export default function VenueSummary({ item, showNoLiveDataStatus = false }: Props) {
  const music = musicStatus(item);
  const showStatus = music.kind !== "noLiveData" || showNoLiveDataStatus;

  return (
    <div className="card-top">
      <DefaultAvatar
        avatarUrl={item.venue.imageUrl ?? undefined}
        name={item.venue.name}
      />

      <div className="group-column">
        <p className="text-b">{item.venue.name}</p>
        <p className="text-pink-400">{item.venue.address ?? ""}</p>

        {showStatus && (
          <span>
            {music.kind === "live" ? (
              <LiveIcon />
            ) : (
              <p className="text-damper">{musicStatusLine(music)}</p>
            )}
          </span>
        )}
      </div>

      {/* Hur det känns i lokalen, inte vad som spelas. Ritar sig själv
          bara när sensorn har en mätning att lita på. */}
      <CrowdChip activity={item.activity} />
    </div>
  );
}
